const toString = Object.prototype.toString;

/**
 * 判断类型
 * @param {unknown} val 值
 * @param {string} type 类型
 * @returns
 */
export function isType(val, type) {
  return toString.call(val) === `[object ${type}]`;
}

/**
 * 是否不等于undefined
 * @param {unknown} val 值
 * @returns
 */
export function isDef(val) {
  return typeof val !== 'undefined';
}

/**
 * 是否等于undefined
 * @param {unknown} val 值
 * @returns
 */
export function isUnDef(val) {
  return !isDef(val);
}

/**
 * 是否为对象
 * @param {any} val 值
 * @returns
 */
export function isObject(val) {
  return val !== null && isType(val, 'Object');
}

/**
 * 是否为空值
 * @param {unknown} val 值
 * @returns
 */
export function isEmpty(val) {
  if (isArray(val) || isString(val)) {
    return val.length === 0;
  }

  if (val instanceof Map || val instanceof Set) {
    return val.size === 0;
  }

  if (isObject(val)) {
    return Object.keys(val).length === 0;
  }

  return false;
}

/**
 * 是否为Date日期
 * @param {unknown} val 值
 * @returns
 */
export function isDate(val) {
  return isType(val, 'Date');
}

/**
 * 是否为null
 * @param {unknown} val 值
 * @returns
 */
export function isNull(val) {
  return val === null;
}

/**
 * 是否不等于null和undefined
 * @param {unknown} val 值
 * @returns
 */
export function isNotNullAndUnDef(val) {
  return isDef(val) && !isNull(val);
}

/**
 * 是否等于null或undefined
 * @param {unknown} val 值
 * @returns
 */
export function isNullOrUnDef(val) {
  return isUnDef(val) || isNull(val);
}

/**
 * 是否为数字类型
 * @param {unknown} val 值
 * @returns
 */
export function isNumber(val) {
  return isType(val, 'Number');
}

/**
 * 是否为Promise实例
 * @param {unknown} val 值
 * @returns
 */
export function isPromise(val) {
  return isType(val, 'Promise') && isObject(val) && isFunction(val.then) && isFunction(val.catch);
}

/**
 * 是否为字符串类型
 * @param {unknown} val 值
 * @returns
 */
export function isString(val) {
  return isType(val, 'String');
}

/**
 * 是否为方法类型
 * @param {unknown} val 值
 * @returns
 */
export function isFunction(val) {
  return typeof val === 'function';
}

/**
 * 是否为布尔类型
 * @param {unknown} val 值
 * @returns
 */
export function isBoolean(val) {
  return isType(val, 'Boolean');
}

/**
 * 是否为正则
 * @param {unknown} val 值
 * @returns
 */
export function isRegExp(val) {
  return isType(val, 'RegExp');
}

/**
 * 是否为数组
 * @param {any} val 值
 * @returns
 */
export function isArray(val) {
  return val && Array.isArray(val);
}

/**
 * 是否为Window
 * @param {any} val 值
 * @returns
 */
export function isWindow(val) {
  return typeof window !== 'undefined' && isType(val, 'Window');
}

/**
 * 是否为元素
 * @param {unknown} val 值
 * @returns
 */
export function isElement(val) {
  return isObject(val) && !!val.tagName;
}

/**
 * 是否为Map实例
 * @param {unknown} val 值
 * @returns
 */
export function isMap(val) {
  return isType(val, 'Map');
}

/**
 * 是否为服务端
 * @param val 值
 * @returns
 */
export const isServer = typeof window === 'undefined';

/**
 * 是否为客户端
 * @param val 值
 * @returns
 */
export const isClient = !isServer;

/**
 * 是否为链接
 * @param {string} path 值
 * @returns
 */
export function isUrl(path) {
  const reg =
    /(((^https?:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)$/;
  return reg.test(path);
}

/**
 * 判断文件后缀
 * @param {string} filePath 文件路径
 * @param {string | string[]} suffixList 后缀名
 * @returns
 */
export function isFileSuffix(filePath, suffixList) {
  // 获取最后一个.的位置
  const index = filePath.lastIndexOf('.');
  // 获取后缀
  const ext = filePath.substring(index + 1);
  return suffixList.includes(ext);
}
